"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WolfCarPanelWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var ExcessExplainedRenderers_1 = require("../../../components/modals/renderers/ExcessExplainedRenderers");
var Types_1 = require("../../../Types");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var AnnualMotorGlassAndRepairExcessWordingGenerator_1 = require("../../../helpers/annual/motor/AnnualMotorGlassAndRepairExcessWordingGenerator");
var WolfCarPanelWidget = exports.WolfCarPanelWidget = /** @class */ (function (_super) {
    __extends(WolfCarPanelWidget, _super);
    function WolfCarPanelWidget(props) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, props) || this;
        _this.previousPremium = 0;
        _this.renderVoluntaryExcessValues = function (voluntaryExcess) {
            var elements = [];
            for (var index = 0; index <= 500; index += 50) {
                elements.push(React.createElement("option", { selected: voluntaryExcess === index, value: index },
                    "\u00A3",
                    index));
            }
            return elements;
        };
        _this.handleSelectOnChangeEvent = function (event) {
            var voluntaryExcess = parseInt(event.target.value, 10);
            var totalExcess = _this.state.compulsoryExcess + voluntaryExcess;
            _this.setState({
                voluntaryExcess: voluntaryExcess,
                totalExcess: totalExcess
            });
            (0, commonFunctions_1.handleChanged)("vehicles[0].annualVehicleExcess.voluntaryExcess", _this.props.interaction, _this.state.initialVoluntaryExcess, voluntaryExcess);
            _this.executeNativeEvent(event);
        };
        var compulsoryExcess = (_a = _this.props.interaction.vehicles[0].annualVehicleExcess) === null || _a === void 0 ? void 0 : _a.compulsoryExcess;
        var voluntaryExcess = (_b = _this.props.interaction.vehicles[0].annualVehicleExcess) === null || _b === void 0 ? void 0 : _b.voluntaryExcess;
        var totalExcess = compulsoryExcess + voluntaryExcess;
        if (_this.props.interaction.product === services_1.PRODUCT_WOLF_MOTOR) {
            _this.previousPremium = _this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL ?
                _this.props.interaction.factors.annualPremium : _this.props.interaction.paymentDetails.instalmentPlan.monthlyPayment;
        }
        _this.state = {
            lookup: [],
            showPopup: false,
            compulsoryExcess: compulsoryExcess,
            voluntaryExcess: voluntaryExcess,
            initialVoluntaryExcess: voluntaryExcess,
            totalExcess: totalExcess
        };
        _this.togglePopUp = _this.togglePopUp.bind(_this);
        return _this;
    }
    WolfCarPanelWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues("carUsage");
    };
    WolfCarPanelWidget.prototype.render = function () {
        return (React.createElement("div", { className: this.getSetting("cssClass", "") }, this.renderCarPanels()));
    };
    WolfCarPanelWidget.prototype.renderCarPanels = function () {
        var _this = this;
        var _a;
        var showPrice = this.getSetting("showPrice", true);
        var carPanels = [];
        var interaction = this.props.engine.getInteraction();
        var monthlyPremium = (_a = interaction.paymentDetails.instalmentPlan) === null || _a === void 0 ? void 0 : _a.monthlyPayment;
        var annualPremium = interaction.factors.annualPremium;
        this.props.interaction.numberOfAdditionalDrivers = interaction.additionalDrivers.length;
        var premiumToDisplay;
        if (this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL) {
            premiumToDisplay = annualPremium === 0 ? this.previousPremium : annualPremium;
        }
        else {
            premiumToDisplay = monthlyPremium === 0 ? this.previousPremium : monthlyPremium;
        }
        this.previousPremium = premiumToDisplay;
        interaction.vehicles.forEach(function (vehicle, index) {
            carPanels.push(React.createElement("div", { className: "panel", key: index },
                React.createElement("img", { className: "vehicle-icon mb-3 car-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-car-icon.png"), alt: "Vehicle icon", "aria-label": "Vehicle icon" }),
                React.createElement("h2", { className: "inner-content text-center font-family-display font-weight-medium mt-0 mb-2" }, "".concat(vehicle.make, ", ").concat(vehicle.model)),
                _this.essentialsSummaryPageJourney() &&
                    React.createElement("span", { className: "registration-number-title font-weight-bold" }, "Car registration number"),
                vehicle.registrationNumber &&
                    React.createElement("div", { className: "number-plate-preview mb-3" }, vehicle.registrationNumber),
                !_this.essentialsSummaryPageJourney() &&
                    React.createElement("div", { className: "mb-3 edit-car-details" },
                        React.createElement("p", { className: "text-center m-0" },
                            React.createElement("a", { className: "text-blue-1 text-decoration-underline", onClick: function () { return _this.editCarDetails(index); } }, "Edit car details"))),
                showPrice &&
                    React.createElement("div", { className: "premium-amount" },
                        React.createElement("p", { className: "h3 text-center font-weight-bold text-blue-1 m-0" }, (0, commonFunctions_1.getAmountToDisplay)(premiumToDisplay)),
                        interaction.factors.premiumType === services_1.PREMIUM_TYPE_ANNUAL ?
                            React.createElement("p", { className: "text-center m-0 small-text" }, "/year") :
                            React.createElement("p", { className: "text-center m-0 small-text" }, "/month")),
                React.createElement("div", { className: "w-100" },
                    React.createElement("img", { className: "margin-tb-30 mw-100", src: "/img/divider-line.svg", alt: "Divider icon", "aria-label": "Divider icon" })),
                React.createElement("h2", { className: "inner-content text-center font-family-display font-weight-medium mt-0 mb-2 driver-title" }, "Drivers"),
                React.createElement("div", { className: "text-center driver-section-container" },
                    _this.renderDrivers(vehicle, index),
                    !_this.essentialsSummaryPageJourney() &&
                        React.createElement(React.Fragment, null, _this.renderAddDriverButton(vehicle)),
                    _this.renderCarUsageInfo()),
                React.createElement("div", { className: "w-100" },
                    React.createElement("img", { className: "margin-tb-30 mw-100", src: "/img/divider-line.svg", alt: "Divider icon", "aria-label": "Divider icon" })),
                React.createElement("h2", { className: "inner-content text-center font-family-display font-weight-medium mt-0 excess-title" },
                    React.createElement("div", null,
                        "Excesses that apply",
                        React.createElement(InfoModal_1.InfoModal, { className: "ml-2", title: "Excess explained", showArrow: false }, (0, ExcessExplainedRenderers_1.renderWolfExcessExplained)(vehicle.annualVehicleExcess)))),
                React.createElement("div", { className: "text-center excess-section-container" }, _this.renderExcessesSection())));
        });
        return carPanels;
    };
    WolfCarPanelWidget.prototype.togglePopUp = function () {
        this.setState(function (state) { return ({
            showPopup: !state.showPopup
        }); });
    };
    WolfCarPanelWidget.prototype.renderDrivers = function (vehicle, vehicleIndex) {
        var _a;
        var _this = this;
        var policyHolderId = this.props.interaction.policyHolder.personId;
        var allDrivers = [this.props.interaction.policyHolder].concat(this.props.interaction.additionalDrivers || []);
        var vehicleDrivers = (0, commonFunctions_1.getVehiclePermanentDrivers)(vehicle, allDrivers);
        var mainDriver = (_a = (0, commonFunctions_1.getVehicleRealMainDriverAndAdditionalDrivers)(vehicleDrivers, vehicle.mainDriverId), _a.mainDriver), additionalDrivers = _a.additionalDrivers;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "driver-section" },
                React.createElement("div", { className: "mb-3 driver-info" },
                    React.createElement("div", { className: "driver-info-name" },
                        mainDriver.firstName,
                        " ",
                        mainDriver.lastName,
                        " (main driver)"),
                    !this.essentialsSummaryPageJourney() &&
                        React.createElement("button", { className: "btn btn-text text-blue-1 w-auto", onClick: function () { return _this.editDriver(mainDriver.personId); }, type: "button", role: "link", id: "editMainDriver", tabIndex: 0 }, "Edit"))),
            this.renderAdditionalDrivers(additionalDrivers, vehicleIndex, policyHolderId)));
    };
    ;
    WolfCarPanelWidget.prototype.renderAddDriverButton = function (vehicle) {
        var _this = this;
        var permanentDrivers = [this.props.interaction.policyHolder].concat(this.props.interaction.additionalDrivers || []);
        var vehiclePermanentDrivers = (0, commonFunctions_1.getVehiclePermanentDrivers)(vehicle, permanentDrivers);
        if (vehiclePermanentDrivers.length >= 6) {
            return (React.createElement(React.Fragment, null));
        }
        else {
            return (React.createElement("button", { className: "pt-3 btn btn-text text-blue-1 w-auto add-driver-btn", onClick: function () { return _this.addDriver(); }, type: "button", role: "link", id: "editMainDriver", tabIndex: 0 }, "Add another driver"));
        }
    };
    WolfCarPanelWidget.prototype.renderAdditionalDrivers = function (vehicleAdditionalDrivers, vehicleIndex, policyHolderId) {
        var _this = this;
        if (vehicleAdditionalDrivers.length > 0) {
            return vehicleAdditionalDrivers.map(function (driver, index) { return (React.createElement("div", { className: "driver-section" },
                React.createElement("div", { key: index, className: "mb-3 driver-info" },
                    React.createElement("div", { id: "additional-driver-full-name", className: "driver-info-name" },
                        driver.firstName,
                        " ",
                        driver.lastName,
                        " (additional driver)"),
                    !_this.essentialsSummaryPageJourney() &&
                        React.createElement(React.Fragment, null,
                            React.createElement("button", { className: "btn btn-text text-blue-1 edit-additional-driver-link", onClick: function () { return _this.editDriver(driver.personId); }, type: "button", role: "link", id: "editMainDriver", tabIndex: 0 }, "Edit"),
                            (driver.personId !== policyHolderId) &&
                                React.createElement("button", { className: "btn btn-text text-blue-1 pl-1", onClick: function () { return _this.removeDriver(driver.personId, vehicleIndex); }, type: "button", role: "link", id: "editMainDriver", tabIndex: 0 }, "Remove"))))); });
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    WolfCarPanelWidget.prototype.editCarDetails = function (vehicleIndex) {
        if (vehicleIndex === 0) {
            this.props.engine.navigate("numberPlateScan", false);
        }
        else {
            this.props.engine.navigate("additionalVehicle".concat(vehicleIndex, "RegistrationNumberPage"), false);
        }
    };
    WolfCarPanelWidget.prototype.essentialsSummaryPageJourney = function () {
        var process = this.props.interaction.process;
        return process === services_1.INTERACTION_PROCESS_MTA_REPLACE_CAR ||
            process === services_1.INTERACTION_PROCESS_MTA_EDIT_CAR_DETAILS ||
            process === services_1.INTERACTION_PROCESS_MTA_ADD_PERMANENT_DRIVER ||
            process === services_1.INTERACTION_PROCESS_CHANGE_ADDRESS ||
            process === services_1.INTERACTION_PROCESS_MTA_EDIT_DRIVER ||
            process === services_1.INTERACTION_PROCESS_MTA_NB_CHANGE_START_DATE ||
            process === services_1.INTERACTION_PROCESS_MTA_EDIT_COVER_LEVEL ||
            process === services_1.INTERACTION_PROCESS_MTA_REMOVE_DRIVER ||
            process.startsWith("mtaSupportPortal");
    };
    WolfCarPanelWidget.prototype.editDriver = function (driverPersonId) {
        return __awaiter(this, void 0, void 0, function () {
            var driverIndex, driverId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        driverIndex = this.findDriverIndex(driverPersonId);
                        driverId = driverIndex + "";
                        if (!(this.props.interaction.process === "nb")) return [3 /*break*/, 5];
                        if (!(driverId === "0")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.engine.navigate("drivingLicenceScan", false)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.props.engine.navigate("editAdditionalDriver".concat(driverId, "DrivingLicenceScanPage"), false)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [3 /*break*/, 11];
                    case 5:
                        if (!(this.props.interaction.process === "renewal")) return [3 /*break*/, 10];
                        if (!(driverId === "0")) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.props.engine.navigate("presetDriverPolicyHolder", false)];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, this.props.engine.navigate("presetDriver".concat(driverIndex - 1), false)];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        if (driverId === "0") {
                            window.location.href = "/journey/init/product/".concat(services_1.PRODUCT_NAME_WOLF_MOTOR, "/process/mtaEditDriverDetails/presetDriverPolicyHolder/").concat(this.props.interaction._id);
                        }
                        else {
                            window.location.href = "/journey/init/product/".concat(services_1.PRODUCT_NAME_WOLF_MOTOR, "/process/mtaEditDriverDetails/presetDriver").concat(driverIndex, "/").concat(this.props.interaction._id);
                        }
                        _a.label = 11;
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    WolfCarPanelWidget.prototype.removeDriver = function (driverPersonId, vehicleIndex) {
        var vehicle = this.props.interaction.vehicles[vehicleIndex];
        var driverIdIndex = vehicle.driverIds.findIndex(function (id) { return id.localeCompare(String(driverPersonId)) === 0; });
        if (driverIdIndex > -1) {
            vehicle.driverIds.splice(driverIdIndex, 1);
        }
        var additionalDrivers = this.props.interaction.additionalDrivers;
        var driverIndex = additionalDrivers.findIndex(function (driver) { return driver.personId.localeCompare(driverPersonId) === 0; });
        if (driverIndex > -1) {
            additionalDrivers.splice(driverIndex, 1);
        }
        // if main driver is deleted and new main driver is not set, Polaris will fail to process such interaction
        if (vehicle.mainDriverId === driverPersonId) {
            vehicle.mainDriverId = this.props.interaction.policyHolder.personId;
        }
        vehicle.numberOfDrivers -= 1;
        this.props.onStateChange("additionalDrivers", additionalDrivers);
        this.changelogRecorder.recordPage("change", this.props, "additionalDrivers");
        this.props.onStateChange("vehicles[".concat(vehicleIndex, "]"), vehicle);
        this.changelogRecorder.recordPage("change", this.props, "vehicles[".concat(vehicleIndex, "]"));
        this.props.interaction.numberOfAdditionalDrivers = this.props.interaction.additionalDrivers.length;
        this.props.onStateChange('numberOfAdditionalDrivers', additionalDrivers.length);
        this.changelogRecorder.recordPage("change", this.props, 'numberOfAdditionalDrivers');
        this.executeEvent("change"); // triggers calculation
    };
    WolfCarPanelWidget.prototype.addDriver = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var allDrivers, driverIndex;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        allDrivers = [this.props.interaction.policyHolder].concat((_a = this.props.interaction.additionalDrivers) !== null && _a !== void 0 ? _a : []);
                        driverIndex = allDrivers.length;
                        if (!(this.props.interaction.process === "nb")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.engine.navigate("additionalDriver".concat(driverIndex, "DrivingLicenceScanPage"), false)];
                    case 1:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 2:
                        if (!(this.props.interaction.process === "renewal")) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.props.engine.navigate('addDriverPresetPage', false)];
                    case 3:
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        window.location.href = "/journey/init/product/".concat(services_1.PRODUCT_NAME_WOLF_MOTOR, "/process/mtaAddPermanentDriver/preset/").concat(this.props.interaction._id);
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    WolfCarPanelWidget.prototype.findDriverIndex = function (driverId) {
        var interaction = this.props.engine.getInteraction();
        if (interaction.additionalDrivers !== null) {
            for (var i = 0; i < interaction.additionalDrivers.length; i++) {
                var driver = interaction.additionalDrivers[i];
                if (driver.personId.localeCompare(driverId) === 0) {
                    return i + 1;
                }
            }
        }
        return 0;
    };
    WolfCarPanelWidget.prototype.renderExcessesSection = function () {
        var vehicle = this.props.interaction.vehicles[0];
        return (React.createElement("div", { className: "text-center font-weight-light excess-section" },
            React.createElement("p", { className: "select-excess" }, "Please select your voluntary excess below."),
            React.createElement("div", { className: "excess-picker" }, this.renderExcessesPicker()),
            React.createElement("p", { className: "selected-excess-info pb-3" },
                "Your voluntary excess is added to the compulsory excess to give you the total amount you\u2019ll have to pay towards ",
                React.createElement("span", { className: "font-weight-bold" }, "any claim"),
                " you make involving accidental damage, fire and theft (but ",
                React.createElement("span", { className: "font-weight-bold" }, "not"),
                " glass-only claims).",
                React.createElement("br", null),
                "Your total excess applies every time you claim and to every car you\u2019re claiming on."),
            AnnualMotorGlassAndRepairExcessWordingGenerator_1.AnnualMotorGlassAndRepairExcessWordingGenerator.getGlassAndRepairExcessWording(vehicle)));
    };
    WolfCarPanelWidget.prototype.renderExcessesPicker = function () {
        var vehicle = this.props.interaction.vehicles[0];
        var compulsoryExcess = vehicle.annualVehicleExcess.compulsoryExcess;
        var voluntaryExcess = vehicle.annualVehicleExcess.voluntaryExcess;
        var totalExcess = compulsoryExcess + voluntaryExcess;
        return (React.createElement("div", null,
            React.createElement("div", { className: "voluntary-excess-picker" },
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "Compulsory"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "voluntary-excess-picker__value" },
                        "\u00A3",
                        compulsoryExcess)),
                React.createElement("div", { className: "voluntary-excess-picker__operation" }, "+"),
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "Voluntary"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "input-group" },
                        React.createElement("select", { id: this.props.question.name, className: "form-control voluntary-excess-picker__dropdown", onChange: this.handleSelectOnChangeEvent, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent, onDoubleClick: this.executeNativeEvent }, this.renderVoluntaryExcessValues(voluntaryExcess)))),
                React.createElement("div", { className: "voluntary-excess-picker__operation" }, "="),
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "TOTAL"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "voluntary-excess-picker__value total-excess" },
                        "\u00A3",
                        totalExcess)))));
    };
    WolfCarPanelWidget.prototype.renderCarUsageInfo = function () {
        var interaction = this.props.engine.getInteraction();
        var classOfUseValue = interaction.vehicles[0].classOfUse;
        this.resolveLookupValue("carUsage", classOfUseValue);
        if (classOfUseValue !== "BU-Class3") {
            return (React.createElement("div", { className: "mt-3 car-usage" },
                React.createElement("span", { className: "font-weight-bold" }, "Car Usage"),
                React.createElement("div", { className: "font-weight-extra-light" }, this.resolveLookupValue("carUsage", classOfUseValue))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    WolfCarPanelWidget.prototype.fetchLookupValues = function (lookupName) {
        var _this = this;
        this.lookupService.fetchLookupValues(lookupName, "en-UK").subscribe(function (lookupValues) {
            _this.state.lookup[lookupName] = lookupValues;
            _this.setState({ lookup: _this.state.lookup });
        }, function () {
            throw new Error("Error: failed to fetch lookup values for '".concat(lookupName, "' lookup"));
        });
    };
    WolfCarPanelWidget.prototype.resolveLookupValue = function (lookupName, lookupId) {
        if (!lookupId || !this.state.lookup || !this.state.lookup[lookupName]) {
            return "";
        }
        var listItem = this.state.lookup[lookupName].find(function (listItem) { return "".concat(listItem.id) === "".concat(lookupId); });
        if (!listItem) {
            throw new Error("Error: no item with id '".concat(lookupId, "' found in lookup '").concat(lookupName, "'"));
        }
        return listItem.value;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], WolfCarPanelWidget.prototype, "changelogRecorder", void 0);
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], WolfCarPanelWidget.prototype, "lookupService", void 0);
    return WolfCarPanelWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=WolfCarPanelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/WolfCarPanelWidget.js
// module id = 3215
// module chunks = 0